import type { DataTableComponentType } from '../blocks/Table/DataTable/types';

export const getFieldKey = (fieldKey: DataTableComponentType['content']['identifier']) => {
  return fieldKey && typeof fieldKey === 'object' ? fieldKey.path : fieldKey;
};
